import { render, staticRenderFns } from "./PagePerformanceReviews.vue?vue&type=template&id=f3e397ac&scoped=true&"
import script from "./PagePerformanceReviews.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviews.vue?vue&type=script&lang=js&"
import style0 from "./PagePerformanceReviews.vue?vue&type=style&index=0&id=f3e397ac&scoped=true&lang=css&"
import style1 from "./PagePerformanceReviews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e397ac",
  null
  
)

export default component.exports